import React, { useEffect, useState } from "react";
import { LogIn, Loader2 } from "lucide-react";
import api from "../lib/api";

export default function ActivityLog() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/notifications/activity").then((r) => setRows(r.data)).catch(() => {}).finally(() => setLoading(false)); }, []);

  return (
    <div>
      <h1 className="font-display text-2xl md:text-3xl font-bold text-[#012a1e]">Login Activity</h1>
      <p className="text-slate-500 mt-1 text-sm">A history of every sign-in across all portals.</p>
      <div className="bg-white rounded-2xl border border-slate-100 mt-5 overflow-x-auto">
        {loading ? <div className="p-12 text-center text-slate-400"><Loader2 className="animate-spin inline" /> Loading…</div> : (
          <table className="w-full text-sm" data-testid="activity-table">
            <thead><tr className="bg-[#f7faf8] text-left text-slate-500">
              <th className="px-4 py-3 font-semibold">User</th><th className="px-4 py-3 font-semibold">Details</th><th className="px-4 py-3 font-semibold">When</th>
            </tr></thead>
            <tbody className="divide-y divide-slate-100">
              {rows.map((r) => (
                <tr key={r.id} className="hover:bg-[#f7faf8]">
                  <td className="px-4 py-3 font-medium text-[#012a1e] flex items-center gap-2"><LogIn size={14} className="text-[#004030]" /> {r.title.replace(" signed in", "")}</td>
                  <td className="px-4 py-3 text-slate-600">{r.body}</td>
                  <td className="px-4 py-3 text-slate-500 whitespace-nowrap">{new Date(r.created_at).toLocaleString()}</td>
                </tr>
              ))}
              {!rows.length && <tr><td colSpan={3} className="px-4 py-10 text-center text-slate-400">No sign-ins recorded yet.</td></tr>}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
